import React from 'react'
import classnames from 'classnames'
import { Icon, Paragraph } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
import { FulfilmentPanelBenefits } from '../index'
import style from '../index.module.scss'

const FulfilmentInfo: React.FC<
  React.PropsWithChildren<{
    iconType: string
    title: string
    titleHref?: string
    memberBenefitsText?: string
    memberBenefitsLink?: {
      href: string
      text: string
    }
    dataTestId: string
  }>
> = ({
  iconType,
  title,
  titleHref,
  memberBenefitsText,
  memberBenefitsLink,
  dataTestId,
}) => {
  return (
    <div className={style.fulfilmentInfoPickerContainer}>
      <Icon
        type={iconType}
        size="medium"
        className={classnames(style.largeIcon, style.fulfilmentIcon)}
      />
      <div
        className={classnames(
          style.infoWrapper,
          !memberBenefitsText && style.floatInfoWrapper
        )}
        data-test-id={dataTestId}
      >
        {titleHref ? (
          <Link to={titleHref} style={{ textDecoration: 'underline' }}>
            <Paragraph
              type="small"
              className={classnames(
                style.fulfilmentTypeTitle,
                style.typeHeading
              )}
            >
              {title}
            </Paragraph>
          </Link>
        ) : (
          <Paragraph
            type="small"
            className={classnames(
              memberBenefitsText && style.fulfilmentTypeTitle,
              style.typeHeading
            )}
          >
            {title}
          </Paragraph>
        )}
        {memberBenefitsText && (
          <FulfilmentPanelBenefits
            memberBenefitsText={memberBenefitsText}
            memberBenefitsLink={memberBenefitsLink}
          />
        )}
      </div>
    </div>
  )
}

export default FulfilmentInfo
